// 组件类型
export const ProjectType = {
    BUILDING: 1,  // 楼栋
    MASSIF: 2,    // 地块
}

export const ProjectTypeList = [
    { value: ProjectType.BUILDING, label: "楼栋项目" },
    { value: ProjectType.MASSIF, label: "地块项目" },
]